import { MapRightSidebar } from 'src/components/MapRightSidebar';
import { MapSidebar } from 'src/components/MapSidebar';
import { ModalRunSimCta } from 'src/components/ModalRunSimCta';
import { ModalSearchLocation } from 'src/components/ModalSearchLocation';
import { ModalEmbedLegends } from 'src/components/ModalEmbedLegends/ModalEmbedLegends';
import React from 'react';
import { SimulationProgressModal } from 'src/components/SimulationProgressModal';
import { TemplateDefault } from 'src/templates/TemplateDefault';
import { WorldMap } from 'src/components/WorldMap';
import { WorldMapContextProvider } from 'src/contexts/WorldMapContext';
import { WorldMapNavigation } from 'src/components/WorldMapNavigation';
import s from './SingularityMap.module.scss';
import { selectReadOnly } from 'src/redux/configuration/configuration.selectors';
import { useConfigurationEffects } from 'src/hooks/useConfigurationEffects';
import { useConfigurationFlowState } from 'src/hooks/useConfigurationFlowState';
import { useAppDispatch } from 'src/redux/store';
import { setOnBoardingStep } from 'src/redux/application/application.slice';
import { useSelector } from 'react-redux';

export const SingularityMap: React.FC = () => {
  return (
    <WorldMapContextProvider>
      <SingularityMapContent />
    </WorldMapContextProvider>
  );
};

const SingularityMapContent: React.FC = () => {
  const dispatch = useAppDispatch();
  // This hook should be used only once per page
  useConfigurationEffects();
  const { graphSimulationProgressShow } = useConfigurationFlowState();
  const readOnly = useSelector(selectReadOnly);

  React.useEffect(() => {
    const seenOnboardingModal = localStorage.getItem('seenOnboardingModal');
    if (!seenOnboardingModal) {
      localStorage.setItem('seenOnboardingModal', 'true');
      dispatch(setOnBoardingStep(1));
    }
  }, [dispatch]);

  return (
    <TemplateDefault>
      <MapSidebar />
      <WorldMapNavigation className={s.mapNavigation} />
      <WorldMap className={s.worldMap} />
      <MapRightSidebar />
      <ModalSearchLocation />
      <ModalEmbedLegends />
      {!readOnly && <ModalRunSimCta />}
      {/* <ModalCanaryWaitlist /> */}
      {graphSimulationProgressShow && <SimulationProgressModal />}
    </TemplateDefault>
  );
};
